"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AccordionItemStateful = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _accordionItem = _interopRequireDefault(require("./accordionItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AccordionItemStateful = function AccordionItemStateful(_ref) {
  var props = _extends({}, _ref);

  return _react.default.createElement(_accordionItem.default, props);
};

exports.AccordionItemStateful = AccordionItemStateful;
AccordionItemStateful.propTypes = {
  children: _propTypes.any.isRequired,
  id: _propTypes.string,
  title: _propTypes.any,
  onClick: _propTypes.func,
  active: _propTypes.bool
};
AccordionItemStateful.displayName = 'AccordionStateful.Item';
var _default = AccordionItemStateful;
exports.default = _default;
AccordionItemStateful.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AccordionStateful.Item",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};